export { default } from './HocAuthenticate';
